
import Vue from 'vue'
import VueMeta from 'vue-meta'
import Buefy from 'buefy'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import VeeValidate, { Validator } from 'vee-validate'
import VeeValidateRu from 'vee-validate/dist/locale/ru'
import App from './App.vue'
import router from './router'
import store from './store'
import { validateMessagesRu } from '@/utils/constants'

import '@mdi/font/scss/materialdesignicons.scss'
import './assets/scss/index.scss'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(Buefy, {
  defaultDayNames: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  defaultMonthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  defaultFirstDayOfWeek: 1
})

VeeValidateRu.messages = {
  ...VeeValidateRu.messages,
  ...validateMessagesRu
}

Vue.use(VeeValidate, {
  events: 'blur'
})

Validator.localize('ru', VeeValidateRu)
Validator.extend('autocomplete', {
  getMessage: () => 'Необходимо выбрать одно из значений',
  validate: (value, params) => (params ? Boolean(params.slug) : false)
})

Validator.extend('phone', {
  getMessage: () => 'Неправильный формат номера телефона',
  validate: (value, phone) => Boolean(String(phone[0]).match(/^\+\d{10,14}$/))
})

Vue.use(VueTinyLazyloadImg)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
  render: h => h(App),
}).$mount('#app')
